import React from 'react';
import ContentContainer from '../components/ContentContainer';
import { Row, Col, Image } from 'react-bootstrap';

import Header from '../components/Header';
import HeaderBar from '../components/HeaderBar';
import SiteContainer from '../components/SiteContainer';
import Title from '../components/Title';
import blogposts from '../assets/blogposts';
import Preview from '../components/Preview';
import PostHtml from '../components/PostHtml';

import fishAndScales from '../assets/essay_images/fish_and_scales.jpg';


const HomeScreen = () => {
  return (
    <SiteContainer>
      <Header />
      <ContentContainer>
        <Row>
          <Col>
            <Title>Welcome!</Title>
            <p>I just finished my PhD in Complex Systems with Josh Bongard.</p>
            <p>I'm now a postdoc at Tufts working under Wesley Clawson and Mike Levin doing experimental biology.</p>
            <p>I like cybernetics, self-organization, AI, ML, and biology. I also like to swing dance and train jiu jitsu.</p>
            <p><strong>Links</strong></p>
            <ul>
              <li><a href="https://twitter.com/kamtb28">Twitter</a></li>
            </ul>
            <p><strong>Contact Me</strong></p>
            <ul>
              <li>eight16-3two5-09six1</li>
              <li><a href="mailto:kamtb28@gmail.com">kamtb28@gmail.com</a></li>
            </ul>
          </Col>
          <Col>
            <Image src={fishAndScales} style={{ width: '100%' }} />
          </Col>
        </Row>
        <hr />
        <p style={{ backgroundColor: 'black', fontSize: 24, color: 'white', paddingLeft: 10 }}><strong>Blog</strong></p>
        {
          blogposts.map((blogpost) => {
            return (<>
              <h3><strong>{blogpost.title}</strong></h3>
              <p>{blogpost.date}</p>
              <PostHtml html={blogpost.html} />
              <hr />
            </>);
          })
        }

      </ContentContainer>
    </SiteContainer>
  )
}

export default HomeScreen;